export default __webpack_public_path__ + "static/article-real-stories-saving-spending-lending-seyma-6f1f3ac4295aa1c3334092be13c32bb3.jpg";